export const AUTH_TOKEN_KEY = 'jargon_ipsum_token';  // or whatever name you want to use